export default "__VITE_ASSET__d7221555__"